export default __webpack_public_path__ + "mobile-faces.91b96d.png";